"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDbOrg = parseDbOrg;
const cloudConfigSchema_1 = require("./cloudConfigSchema");
function parseDbOrg(dbOrg) {
    const { cloudConfig, ...org } = dbOrg;
    const parsedCloudConfig = cloudConfigSchema_1.CloudConfigSchema.safeParse(cloudConfig);
    const parsedOrg = {
        ...org,
        cloudConfig: parsedCloudConfig.success ? parsedCloudConfig.data : null,
    };
    return parsedOrg;
}
